export function getFallbackStateTransactions({ isLoading, allTransactions, filteredTransactions }) {
  if (isLoading) return { state: "loading" };

  if (!allTransactions || allTransactions.length === 0) {
    return { state: "noData" };
  }

  if (filteredTransactions.length === 0) {
    return { state: "noMatch" };
  }

  return { state: "ok" };
}
